export default "__VITE_ASSET__BLre7UmZ__"